import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import {
	INodeLocation,
	NodeLocation,
	NodeLocationFactory,
	NodeLocationFactoryFromJS
} from '../INodeLocation';

interface IBaseBaseAction {
	id: string;
	name: string;
}

export interface IBaseAction extends IBaseBaseAction {
	loc: INodeLocation;
}

export interface ReadOnlyBaseAction extends IBaseBaseAction {
	loc: NodeLocation;
}

export type BaseAction = ReadonlyRecord<ReadOnlyBaseAction>;

export const BaseActionFactory = Record<ReadOnlyBaseAction>({
	id: null,
	name: null,
	loc: NodeLocationFactory()
});

export const BaseActionFactoryFromJS = function (data: IBaseAction) {
	return BaseActionFactory({
		...data,
		loc: data.loc ? NodeLocationFactoryFromJS(data.loc) : null
	});
};
